// The pill used to switch a list between open / resolved views. Shared so the
// pilot squawk list and the admin one look and behave the same.
export function FilterChip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`rounded-md px-3 py-1.5 ${
        active ? 'bg-brand text-white' : 'bg-white text-navy-900 ring-1 ring-inset ring-navy-900/15'
      }`}
    >
      {children}
    </button>
  );
}
